import styled from 'styled-components';

export const Root = styled.div`
    width: 100%;
    background: #384650;
    padding: 10px 60px;
    border-bottom: 1px solid #767280;
`;
